const LEGACY_LANGUAGE_MAP = {
  "en-US": "en",
  en: "en",
  hi: "hi",
  marathi: "mr",
  mr: "mr",
  telegu: "te",
  te: "te"
};

export const SUPPORTED_LANGUAGES = ["en", "hi", "mr", "te"];

export const normalizeLanguageCode = (language) => {
  if (!language) {
    return "en";
  }

  const normalized = LEGACY_LANGUAGE_MAP[language] || language.split("-")[0];
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : "en";
};

export const getStoredLanguage = () => {
  const storedLanguage = localStorage.getItem("selectedLanguage");
  const normalizedLanguage = normalizeLanguageCode(storedLanguage);

  if (storedLanguage !== normalizedLanguage) {
    localStorage.setItem("selectedLanguage", normalizedLanguage);
  }

  return normalizedLanguage;
};
